import Phrase from 'libs/translationsUtils/phrase'
import tracker from '../../components/tracker/publish'

const eventTracker = () => {
  tracker.trackEvent('userevent', {
    type: 'Topic Initiated',
    click_source: 'Knowledge Base'
  })
}

const AskQuestionWidget = (props) => (
  <div className='ask-question-widget__widget'>
    <div class='ask-question-widget__title'>
      <Phrase p='ask.question.widget.title' />
    </div>
    <div class='ask-question-widget__button'>
      <a href='topic/new' class='btn--cta btn--new-topic qa-topic-new-button pull-right' onClick={() => eventTracker()}>
        <Phrase p='ask.question.widget.button' />
      </a>
    </div>
  </div>
)

export default AskQuestionWidget
